var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("page-layout", [
    _c("div", { staticClass: "not-found" }, [_vm._v("Not Found")])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }